import ConnectedSplitLoanCriteria from './SplitLoanCriteria';

export default ConnectedSplitLoanCriteria;
